/**
 * saya masih bingung kenapa active menu dan active tab tidak bisa disatukan
 * ketika saya coba satukan antara active menu dan active tab, ketika berpindah tab
 * data tidak terisi
 *
 * update 03/08/22
 *
 */

export const initialStatePageProps = {
  wrapper_page_props: "",
  /**
   * PAGE
   */
  page_input_penjualan: null,
  page_input_tagihan: null,
  page_input_rekap_tagihan: null,

  page_wf_purchase_order: null,
  page_wf_mutasi_item: null,

  page_neraca_bulan_detail: null,
  page_jurnal_umum: null,
  page_laba_rugi_detail: null,

  page_detail_rekap_jasmed: null,

  /**
   * END PAGE
   */
};

export const initialState = {
  // Notifikasi
  notifikasi_list: [],
  notifikasi_count: 0,
  // End Notifikasi

  wrapper_minimize: false,
  wrapper_active_menu: null,
  wrapper_active_tab: null,
  wrapper_tabs: [],
  wrapper_loading: false,
  wrapper_insurance_bpjs_id: null,

  theme_list: {},

  ...initialStatePageProps,
};

export const actions = {
  CHANGE_ACTIVE_MENU: "CHANGE_ACTIVE_MENU",
  CHANGE_ACTIVE_TAB: "CHANGE_ACTIVE_TAB",
  CHANGE_MINIMIZE: "CHANGE_MINIMIZE",

  CHANGE_TABS: "CHANGE_TABS",
  CHANGE_LOADING: "CHANGE_LOADING",
  CHANGE_PAGE_PROPS: "CHANGE_PAGE_PROPS",
  RESET_PAGE_PROPS: "RESET_PAGE_PROPS",

  CHANGE_INSURANCE_BPJS_ID: "CHANGE_INSURANCE_BPJS_ID",

  CHANGE_NOTIFIKASI_LIST: "CHANGE_NOTIFIKASI_LIST",
  CHANGE_NOTIFIKASI_COUNT: "CHANGE_NOTIFIKASI_COUNT",

  CHANGE_PROPS_PAGE_INPUT_PENJUALAN: "CHANGE_PROPS_PAGE_INPUT_PENJUALAN",
  CHANGE_PROPS_PAGE_INPUT_TAGIHAN: "CHANGE_PROPS_PAGE_INPUT_TAGIHAN",
  CHANGE_PROPS_PAGE_INPUT_REKAP_TAGIHAN:
    "CHANGE_PROPS_PAGE_INPUT_REKAP_TAGIHAN",
  CHANGE_PROPS_PAGE_NERACA_BULAN_DETAIL:
    "CHANGE_PROPS_PAGE_NERACA_BULAN_DETAIL",
  CHANGE_PROPS_PAGE_JURNAL_UMUM: "CHANGE_PROPS_PAGE_JURNAL_UMUM",
  CHANGE_PROPS_PAGE_LABA_RUGI_DETAIL: "CHANGE_PROPS_PAGE_LABA_RUGI_DETAIL",
  CHANGE_PROPS_PAGE_WF_PURCHASE_ORDER: "CHANGE_PROPS_PAGE_WF_PURCHASE_ORDER",
  CHANGE_PROPS_PAGE_WF_MUTASI_ITEM: "CHANGE_PROPS_PAGE_WF_MUTASI_ITEM",

  CHANGE_PROPS_PAGE_DETAIL_REKAP_JASMED:
    "CHANGE_PROPS_PAGE_DETAIL_REKAP_JASMED",
  CHANGE_PROPS_THEME: "CHANGE_PROPS_THEME",
};
